import { isRolePermissionResponse, } from '@urbanik/api-contracts';
import { RoleCatalogApiError } from './role-catalog.js';
async function call(baseUrl, path, init) {
    let response;
    try {
        response = await fetch(baseUrl.replace(/\/$/, '') + path, { ...init, credentials: 'include' });
    }
    catch {
        throw new RoleCatalogApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    if (!response.ok) {
        const body = (await response.json().catch(() => null));
        const kind = response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 409
                    ? 'conflict'
                    : response.status === 400
                        ? 'validation'
                        : 'unavailable';
        throw new RoleCatalogApiError(kind, body?.message ?? 'No pudimos completar la operación.');
    }
    const body = await response.json();
    if (!isRolePermissionResponse(body))
        throw new RoleCatalogApiError('unavailable', 'La matriz recibida no es válida.');
    return body;
}
export const getRolePermissions = (baseUrl, roleId, signal) => call(baseUrl, '/identity/admin/roles/' + encodeURIComponent(roleId) + '/permissions', {
    headers: { Accept: 'application/json' },
    signal: signal ?? null,
});
export const replaceRolePermissions = (baseUrl, roleId, input) => call(baseUrl, '/identity/admin/roles/' + encodeURIComponent(roleId) + '/permissions', {
    method: 'PUT',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
});
